/**
 * f11.6: the amber triangle with a count, whose tooltip is the line's
 * `ValidationWarningList`. Focusable, so the tooltip opens from the keyboard.
 * A warning is never a denial: no lock, no ban, no danger token.
 */

import { AlertTriangle } from 'lucide-react';

import type { EngineWarning, ValidationWarning } from '@/api/client';

import { ValidationWarningList } from './ValidationWarningList';

interface ValidationWarningBadgeProps {
  count: number;
  warnings: readonly ValidationWarning[];
  engineWarnings?: readonly EngineWarning[];
}

export function ValidationWarningBadge({ count, warnings, engineWarnings }: ValidationWarningBadgeProps) {
  if (count <= 0) return null;
  const label = `${count} warning${count === 1 ? '' : 's'} — saving is never blocked`;
  return (
    <span className="vw-badge" tabIndex={0} aria-label={label} data-severity="warning">
      <AlertTriangle aria-hidden="true" />
      <span className="vw-count">{count}</span>
      <span className="vw-tip" role="tooltip">
        <ValidationWarningList warnings={warnings} engineWarnings={engineWarnings} />
      </span>
    </span>
  );
}
